import { FeedbackMappedType } from 'src/types/generic';
import { IConversations } from 'src/types/serviceResponseTypes';

/**
 * Mapper to add feedback flag to conversations
 */

export default function withFeedbackMapper(
  converations: IConversations,
  feedbackData: Array<FeedbackMappedType>
) {
  return {
    ...converations,
    messages: converations.messages.map((previousMessage) => ({
      ...previousMessage,
      feedback: getFeedbackForMessage(previousMessage.id, feedbackData),
    })),
  };
}

function getFeedbackForMessage(
  messageId: number,
  feedbackData: Array<FeedbackMappedType>
): FeedbackMappedType {
  const feedback = feedbackData.find((data) => data.messageId === messageId);

  return {
    messageId,
    disabled: Boolean(feedback?.isPositiveMarked || feedback?.isNegativeMarked),
    isPositiveMarked: Boolean(feedback?.isPositiveMarked),
    isNegativeMarked: Boolean(feedback?.isNegativeMarked),
  };
}
